import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import SelectInput from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select/Input';

const WebformDate = (props) => {
  const { entity, setFieldValue, values, errors, touched } = props;
  const { t } = useTranslation();
  // Set all states for the date.
  const [day, setDay] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();

  const title = entity.get('#title');
  const key = entity.get('#webform_key');
  const required = entity.get('#required');
  const requiredError = entity.get('#required_error');

  const dateMin = parseInt(entity.get('#date_date_min')) + 1 || 1970;
  const dateMax = parseInt(entity.get('#date_date_max')) || 2070;

  const placeholderDay = 'Dag';
  const placeholderMonth = 'Maand';
  const placeholderYear = 'Jaar';

  // Render all day options possible.
  const renderDayOptions = useCallback((placeholder) => {
    const options = [];

    if (placeholder) {
      options.push({ value: placeholder, label: placeholder });
    }

    for (let index = 1; index <= 31; index++) {
      options.push({ value: index, label: index });
    }

    return options;
  }, []);

  // Render all options possible for months.
  const renderMonthOptions = useCallback(() => {
    const months = [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December',
    ];

    return months.map((e, i) => {
      return { value: i + 1, label: e };
    });
  }, []);

  // Render all options for possible years from
  // the DateMin and DateMax variables.
  const renderYearOptions = useCallback(() => {
    const options = [];

    for (let index = dateMin; index <= dateMax; index++) {
      options.push({ value: index, label: index });
    }

    return options;
  }, [dateMax, dateMin]);

  useEffect(() => {
    // If one of these is not set return.
    if (!day || !month || !year) {
      errors[key] = requiredError || t(['webform.components.date.invalid', 'webform.invalid', 'webform_invalid']);
      return;
    }

    if (day === placeholderDay || month === placeholderMonth || year === placeholderYear) {
      errors[key] = requiredError || t(['webform.components.date.invalid', 'webform.invalid', 'webform_invalid']);
      return;
    }

    setFieldValue(key, `${year}-${month}-${day}`);
  }, [day, month, year, key, setFieldValue, errors, requiredError, t]);

  // If birthday is invalid, like 2000/02/30,
  // set an error.
  if ((day && month && year) && (Number.isNaN(Date.parse(values[key])) || day === placeholderDay || month === placeholderMonth || year === placeholderYear)) {
    errors[key] = requiredError || t(['webform.components.date.invalid', 'webform.invalid', 'webform_invalid']);
  } else {
    delete errors[key];
  }

  if (required && (!day || !month || !year)) {
    errors[key] = requiredError || t(['webform.components.date.required', 'webform.required', 'webform_required']);
  }

  const wrapperClassNames = c('WebformDate', entity.getIn(['#wrapper_attributes', 'class', 0], ''), { 'error': touched[key] && errors[key] });
  const labelClassNames = entity.getIn(['#label_attributes', 'class', 0], '');

  return (
    <div className={wrapperClassNames} onClick={() => { touched[key] = true; }}>
      {title && <label className={labelClassNames} htmlFor={key}>{title}{!required && '(optioneel)'}</label>}
      <div className="WebformDate__inner">
        <SelectInput fieldName="day" options={renderDayOptions()} value={day} placeholder={placeholderDay} onChange={(e) => { setDay(e < 10 ? `0${e}` : e); }} />
        <SelectInput fieldName="month" options={renderMonthOptions()} value={month} placeholder={placeholderMonth} onChange={(e) => { setMonth(e < 10 ? `0${e}` : e); }} />
        <SelectInput fieldName="year" options={renderYearOptions()} value={year} placeholder={placeholderYear} onChange={(e) => { setYear(e); }} />
      </div>
      {errors[key] && touched[key] ? <div className="WebformDate_error WebformComponent--error">{errors[key]}</div> : null}
    </div>
  );
};

export default WebformDate;
